// extracted by mini-css-extract-plugin
module.exports = {"main":"ChatRoomAligner_main__3x7Po","own-message":"ChatRoomAligner_own-message__24Kt1"};